import * as React from 'react';
import {Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import ContactPhone from "./contactPhone";

export default function RegistrationSuccessModal() {
    const {t} = useTranslation('startPage')
    return (
        <>
            <Typography mb='20px'>
                {t('wellDone')}
            </Typography>
            <Typography mb='20px'>
                {t('overlayText')}
            </Typography>
            <ContactPhone/>
        </>
    )
}